"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserParamsSchema = exports.UserFieldSchema = exports.UserConfigParamsSchema = exports.UserConfigFieldSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("./util");
const query_1 = require("./query");
const user_1 = require("./user");
exports.UserConfigFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(user_1.UserConfigSchema));
exports.UserConfigParamsSchema = (0, query_1.paramsSchema)(exports.UserConfigFieldSchema).strict();
exports.UserFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(user_1.UserSchema));
exports.UserParamsSchema = (0, query_1.paramsSchema)(exports.UserFieldSchema).strict();
//# sourceMappingURL=userQuery.js.map